import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MtIsGrantedDirective } from './directives/mt-is-granted/mt-is-granted.directive';
import { SessionAlertComponent } from './components/session-alert/session-alert.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { DsButtonModule } from 'design-system';
import { ACCESS_TOKEN_TIME_SHIFT, REFRESH_TOKEN_TIME_SHIFT, USER_ACTIVITY_TIME_SHIFT, COUNTER_START_VALUE } from './utils/tokens';

@NgModule({
  declarations: [MtIsGrantedDirective, SessionAlertComponent],
  imports: [CommonModule, DynamicDialogModule, DsButtonModule],
  exports: [MtIsGrantedDirective],
  providers: [
    {
      provide: ACCESS_TOKEN_TIME_SHIFT,
      useValue: 20,
    },
    {
      provide: REFRESH_TOKEN_TIME_SHIFT,
      useValue: 121,
    },
    {
      provide: USER_ACTIVITY_TIME_SHIFT,
      useValue: 60,
    },
    {
      provide: COUNTER_START_VALUE,
      useValue: 120,
    },
  ],
})
export class ModulTosamosciModule {}
